shadow$provide[266] = function(require,module,exports) {
var require$_DOT__SLASH_clock_DOT_js = require("./clock.js");
var require$_DOT__SLASH_now_DOT_js = require("./now.js");
require.exportCopy(module, require$_DOT__SLASH_clock_DOT_js);
require.exportCopy(module, require$_DOT__SLASH_now_DOT_js);

};